<template>
    <div>
        <v-toolbar flat :color="color" height="40" dark>
            <v-toolbar-title>
                {{ $t(title) }}
            </v-toolbar-title>
        </v-toolbar>
    </div>
</template>

<script>
import useSharedMethod from "@/use/SharedMethod.js";
import {onMounted, ref, watch} from "vue";

export default {
    name: "WDialogToolbar",
    props: {
        title: String,
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        renewAction: Boolean,
        archiveAction: Boolean,
        unarchiveAction: Boolean,
        activateAction: Boolean,
        printAction: Boolean,
        launchAction: Boolean,
        lockAction: Boolean,
        unlockAction: Boolean,
    },
    setup(props) {
        const {getDialogToolbar} = useSharedMethod();
        
        const title = ref(null);
        const color = ref(null);
        
        watch(() => props, () => {
            let result = getDialogToolbar(props);
            title.value = props.title ? props.title : result?.title;
            color.value = result?.color;
        }, {deep: true, immediate: true});
        
        onMounted(() => {
        
        });
        
        return {
            title,
            color,
        }
    }
}
</script>

<style scoped>

</style>